import React from 'react';
import apiclient from 'lib/apiclient';
import useAreas from 'hooks/useAreas';
import { useHistory } from 'react-router-dom';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { Formik, Form as FormikForm, Field} from 'formik';

const Table = (props) => {
  const areas = useAreas();
  const {
    onSubmit: handleSubmit
  } = props;

  return (
    <Formik initialValues={{
      id : '',
      employeeNumber : '',
      name : '',
      kana : '',
      areaId : 'tokyo',
      canSell : false,
      canSupport : false,
    }} onSubmit={handleSubmit}>
      <Form tag={FormikForm}>
        <FormGroup>
          <Label for="id">ID</Label>
          <Input tag={Field} id="id" name="id" placeholder="ID" />
        </FormGroup>
        <FormGroup>
          <Label for="employeeNumber">社員番号</Label>
          <Input tag={Field} id="employeeNumber" name="employeeNumber" placeholder="社員番号" />
        </FormGroup>
        <FormGroup>
          <Label for="name">氏名</Label>
          <Input tag={Field} id="name" name="name" placeholder="氏名" />
        </FormGroup>
        <FormGroup>
          <Label for="kana">カナ</Label>
          <Input tag={Field} id="kana" name="kana" placeholder="氏名（カナ）" />
        </FormGroup>
        <FormGroup>
          <Label for="area">エリア</Label>
          <Input tag={Field} as="select" id="area" name="areaId">
            {areas.map(area => <option key={area.id} value={area.id}>{area.name}</option>)}
          </Input>
        </FormGroup>
        <FormGroup check>
          <Label check><Input tag={Field} type="checkbox" name="canSell" />{' '}営業担当者</Label>
        </FormGroup>
        <FormGroup check>
          <Label check><Input tag={Field} type="checkbox" name="canSupport" />{' '}サポート担当者</Label>
        </FormGroup>
        <Button>保存</Button>
      </Form>
    </Formik>
  );
}

export default (props) => {
  const history = useHistory();

  const handleSubmit = React.useCallback((model) => {
    apiclient.post('api/coordinator', model)
      .then((response) => {
        alert(response.data.apiKey);
        history.goBack();
      });
  }, []);

  return (
    <div>
      <h1 id="tabelLabel" ><span onClick={() => history.goBack()}>担当者一覧</span> &#12297; 新規作成</h1>
      <Table onSubmit={handleSubmit} />
    </div>
  );
}